import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LogoutComponent } from './auth/logout/logout.component';
import { AuthGuard } from './auth/_guards/auth.guard';
import { SavingsEstimateComponent } from './savings-estimate/savings-estimate.component';

const routes: Routes = [
  { path: 'login', loadChildren: './auth/auth.module#AuthModule' },
  {
    path: 'savings-estimate',
    component: SavingsEstimateComponent
  },
  { path: '*', redirectTo: 'index', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts